import ApiCodePanel from 'shiplab-components/data-access/ApiCodePanel';
import { DataAccessText } from 'shiplab-components/data-access/dataAccessTypography';

type CopyableCodeBlockProps = {
  code: string;
  title?: string;
  description?: string;
};

const CopyableCodeBlock = ({ code, title, description }: CopyableCodeBlockProps) => (
  <div className="mb-3">
    {description && <DataAccessText className="text-700 mb-2">{description}</DataAccessText>}
    <ApiCodePanel label={title ?? 'Path pattern'} variant="snippet" code={code} />
  </div>
);

export default CopyableCodeBlock;
